import { Apple, Bot, Smartphone } from 'lucide-react';
import type { AdminPushDevice } from 'app/javascript/types/admin';

interface DevicePlatformIconsProps {
  devices: AdminPushDevice[];
}

export default function DevicePlatformIcons({ devices }: DevicePlatformIconsProps) {
  const platforms = new Set(devices.map((device) => device.platform));
  const hasIos = platforms.has('apple');
  const hasAndroid = platforms.has('google');
  const hasUnknown = [...platforms].some((platform) => platform !== 'apple' && platform !== 'google');

  if (platforms.size === 0) return <span className="text-muted-foreground">—</span>;

  const labels = [hasIos && 'iOS', hasAndroid && 'Android', hasUnknown && 'outro dispositivo'].filter(Boolean);

  return (
    <span className="inline-flex items-center gap-1.5" aria-label={labels.join(' e ')}>
      {hasIos && (
        <span
          className="inline-flex size-7 items-center justify-center rounded-lg border border-border bg-secondary/70 text-muted-foreground"
          title="iOS"
        >
          <Apple className="size-4" aria-hidden />
        </span>
      )}
      {hasAndroid && (
        <span
          className="inline-flex size-7 items-center justify-center rounded-lg border border-border bg-secondary/70 text-muted-foreground"
          title="Android"
        >
          <Bot className="size-4" aria-hidden />
        </span>
      )}
      {hasUnknown && (
        <span
          className="inline-flex size-7 items-center justify-center rounded-lg border border-border bg-secondary/70 text-muted-foreground"
          title="Outro dispositivo"
        >
          <Smartphone className="size-4" aria-hidden />
        </span>
      )}
    </span>
  );
}
